export default "__VITE_ASSET__Chhnoh1$__"